import styled from "styled-components";
import { skeletonizeStyles } from "../components/skeleton/Skeleton.Parts";

/**
 * This function takes a React component and returns a new component that has
 * a skeleton loading effect applied to it. The skeleton effect is achieved
 * using styled-components and CSS animations.
 * In order to work, the component passed in must have a className prop.
 *
 * @param {React.ComponentType<P>} Component The React component with className prop.
 * @returns {StyledComponent<React.ComponentType<WithClassName<P>>, object, object, never>} A new component with the skeleton loading effect.
 */
export const skeletonize = <P extends { className?: string }>(
  Component: React.ComponentType<P>,
) => {
  const Skeleton = styled(Component)`
    ${skeletonizeStyles}
  `;

  return Skeleton;
};
